import { Meta, Title } from '@angular/platform-browser';
import { Component, OnInit, ViewChild, HostListener, OnDestroy, Output, EventEmitter, ChangeDetectionStrategy, TemplateRef, Inject } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
// import { ProductDialogComponent } from '../../shared/products-carousel/product-dialog/product-dialog.component';
import { Settings, AppSettings } from 'src/app/app.settings';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ScreenBreakpoint } from 'src/app/theme/utils/screen-breakpoint';
import { DatePipe, DecimalPipe } from '@angular/common';
import { PopupComponent } from '../../../../theme/components/popup/popup.component';
import { CartDialogComponent } from '../../../../shared/cart/cart-dialog/cart-dialog.component';
import { combineLatest } from 'rxjs';
import { DestroySubscribers, isAllowToCreateOrderOrAddProduct } from '../../../../theme/utils/util-functions';
import { ReplacePipe } from '../../../../theme/pipes/replace.pipe';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { CookieService } from 'ngx-cookie-service';
import { HttpParams } from '@angular/common/http';
import { Location } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  checkDeliveryCalendarOrderStatus,
  checkCutoffDate,
  checkCutoffTime,
  checkDeliveryCalenderAndCutOffTime
} from 'src/app/theme/utils/util-functions';
import { PaginationInstance } from 'ngx-pagination';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AppHeaderService } from 'src/app/theme/utils/app-header.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// import { LoadcomponentService } from '../../loadcomponent.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})

@DestroySubscribers()
export class ProductsComponent implements OnInit, OnDestroy, OnDestroy {
  @ViewChild('sidenav', { static: true }) sidenav: any;
  @ViewChild('productDialog', { static: true }) productDialog: TemplateRef<any>;
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();

  sortingOptions = [
    { display: 'Default Sorting', value: 'default', selected: true },
    { display: 'Sort by popularity', value: 'popularity', selected: false },
    { display: 'Sort by featured', value: 'featured', selected: false },
    { display: 'Sort by newness', value: 'newness', selected: false },
    { display: 'Sort by price: low to high', value: 'lowtohigh', selected: false },
    { display: 'Sort by price: high to low', value: 'hightolow', selected: false },
    { display: 'Sort by name: A - Z', value: 'atoz', selected: false },
    { display: 'Sort by name: Z - A', value: 'ztoa', selected: false },
  ]
  public selectedSorting;
  public swiperConfig: SwiperConfigInterface = {};
  productNotAvailable: boolean = false;
  productDialogRef;
  public sidenavOpen: boolean = false;
  public sidenavMode: string;
  private sub: any;
  private params;
  public storeDetails = {};
  storeDetailsJson = {};
  cutOffTime = []
  current_date_time = null;
  private queryParams;
  categoryDescription = '';
  url = this.router.url.split('?')[0];
  public viewType: string = 'grid';
  public viewCol: number = 25;
  public viewColMob: number = 100;
  // public counts = [24, 36, 48];
  public counts = [12, 24, 60];
  public count: any;
  public sortings = ['Sort by Default', 'Best match', 'Lowest first', 'Highest first'];
  public sort: any;
  products = [];
  product;
  public categories = [];
  featureTags = {};
  category = {};
  categoryName;
  categoryWebsiteMessage;
  subCategories = [];
  selectedDeliveryCalendar = {};
  public brands = [];
  public page: any = 1;
  public existPCat: any;
  subService;
  loginSubService;
  public settings: Settings;
  isMobile = false;
  shoppingCartStatusBarData = {
    items: 0,
    total: 0.00
  };
  localStorageCartProd;
  cartProductIds = [];
  array = [1, 2, 3, 4, 5];
  loggedIn = false;
  userDetails = {};
  dateFormat;
  totalProductsCount = 0;
  pageParam;
  previosulyOrdered: string;
  pageLoaded: boolean = false;
  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  supplier_info = {};
  totalTaxCollectedAmount: number = 0;
  public productTabs = [];
  public productDescription;
  public zoomImage: any;
  thumbImage;
  fullImage;
  mainImage;
  mainImageName;
  imageUrl = environment.imageUrl;
  data: any;
  chkload: boolean;
  chkCategory: boolean;
  chkProduct: boolean = false;
  chkRoute: string;
  private destroy$ = new Subject<void>();
  sanitizedDescription: SafeHtml | null = null;
  isFeatureTagMoblieIssue: boolean = false;
  FeatureTagProbadgeImgFit: boolean = false;
  isFeatureTagShowTwoLineDescription: boolean = false;
  updatedSortingOptions: { display: string; value: string; selected: boolean; }[];
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    public appSettings: AppSettings,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private subscriptionService: SubscriptionService,
    public dialog: MatDialog,
    private screenBreakpoint: ScreenBreakpoint,
    public router: Router,
    private meta: Meta,
    private title: Title,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private replacePipe: ReplacePipe,
    private cookieService: CookieService,
    private readonly location: Location,
    private subscription: SubscriptionService,
    public sharedDataService: SharedDataService,
    private notification: NotificationService,
    private appHeaderService: AppHeaderService,
    private sanitizer: DomSanitizer,
    // public loadComponentService: LoadcomponentService,
  ) {
    this.settings = this.appSettings.settings;
    if (this.router.url.includes('categories')) {
      this.chkCategory = true;
    } else if (this.router.url.includes('vendors')) {
      this.chkCategory = false;
      // } else if (this.router.url.includes('all-products')) {
    } else if (this.router.url.includes('products')) {
      this.chkProduct = true;
    }
  }

  ngOnInit() {
    this.featureTags = JSON.parse(
      sessionStorage.getItem("featureTags")
    );
    this.isFeatureTagMoblieIssue = !!this.featureTags && this.featureTags['sf_mobile_view_issue'] ? true : false;
    this.FeatureTagProbadgeImgFit = !!this.featureTags && this.featureTags['sf_product_badges_issues'] ? true : false ;
    this.isFeatureTagShowTwoLineDescription = !!this.featureTags && this.featureTags['ftag_sf_show_two_line_description_in_product_card'] ? true : false;    
    this.sharedDataService.cartResponse$
      .pipe(takeUntil(this.destroy$))  // Automatically unsubscribe when destroyed
      .subscribe(data => {
        if (data) {
          this.refreshCategory();
          //this.getQueryAndQueryparams();
          // this.getCartCount();
          // Ensure we only emit `false` when needed and avoid looping
          if (data !== false) {
            this.sharedDataService.cartResponse$.next(false);
          }
        }
      });
    this.count = !!JSON.parse(localStorage.getItem('pageCount')) ? JSON.parse(localStorage.getItem('pageCount'))['count'] : this.counts[0];
    try {
      this.subscriptionService
        .getEmitCloseDialogueSubject()
        .pipe(takeUntil(this.destroy$))
        .subscribe((arg) => {
          if (this.productDialogRef) {
            this.productDialogRef?.close();
          }

        });
      this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.pageParam = params.page || null;
        this.page = this.pageParam;
        if (this.pageParam) {
          //this.getQueryAndQueryparams();
          this.refreshCategory();

        } else {
          this.pageParam = 1;
          this.page = this.pageParam;
          this.scrollToTop();
        }
      });

      this.pageParam = this.activatedRoute.snapshot.queryParamMap.get('page');
      this.page = this.pageParam
    } catch (error) {
      console.log(error);
    }
    if (!!this.pageParam && this.pageParam === '1' || this.pageParam === 1) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute, queryParams: { page: null },
        queryParamsHandling: "merge",
      });
    }
    this.isMobile = this.screenBreakpoint.checkScreenBreakpoint('screen and (max-width: 959px)');

    this.sort = this.sortings[0];
    this.storeDetails = this.activatedRoute.snapshot.data['store']['response']['data']['store'];
    this.storeDetailsJson = this.activatedRoute['snapshot']['data']['store']['response']['data']['store_json'];
    // save store details in session start
    let sortingSelected = !!sessionStorage.getItem('sorting') ? JSON.parse(sessionStorage.getItem('sorting'))['value'] : !!this.storeDetails['sf_product_sorting'] ? this.storeDetails['sf_product_sorting'] : 'default';
    if(!!this.featureTags && this.featureTags['ftag_sf_previously_ordered_products']){ 
      if (this.router.url.includes('/previously-ordered') &&sortingSelected === 'popularity') {
        sortingSelected = 'mostpurchased';
      }
      else if (!this.router.url.includes('/previously-ordered') && sortingSelected === 'mostpurchased') {
        sortingSelected = 'popularity';
      }
    }
    this.selectedSortingValue(sortingSelected);
    sessionStorage.setItem('store', JSON.stringify({
      id: this.storeDetails['id'],
      name: this.storeDetails['name'],
      logo: this.storeDetails['logo'],
      address: this.storeDetails['address'],
      phone: this.storeDetails['phone'],
      currency: this.storeDetails['currency'],
      site_maintenance: this.storeDetails['site_maintenance'],
      cart_without_registration: this.storeDetails['cart_without_registration'],
      cc_collection_point: this.storeDetails['cc_collection_point'],
      delivery_address_input_preference: this.storeDetails['delivery_address_input_preference'],
      automatic_route_assignment: this.storeDetails['automatic_route_assignment'],
      waitlist_for_non_service_areas: this.storeDetails['waitlist_for_non_service_areas'],
      delivery_fee: this.storeDetails['delivery_fee'],
      fulfillment_options: this.storeDetails['fulfillment_options'],
      delivery_upper_limit: this.storeDetails['delivery_upper_limit'],
      rate_per_bottle: this.storeDetails['rate_per_bottle'],
      date_format: this.storeDetails['date_format'],
      time_zone: this.storeDetails['time_zone'],
      order_cut_off_day: this.storeDetails['order_cut_off_day'],
      order_cut_off_time: this.storeDetails['order_cut_off_time'],
      siteTitle: this.storeDetailsJson['settings']['siteTitlePrefix'],
      minimum_order_value: this.storeDetails['minimum_order_value']
    }));
    // save store details in session end
    // this.page = !!this.pageParam ? this.pageParam : 1;
    this.getUserDetails();
    if (!!this.cookieService.get('rememberMe')) {
      const rememberMe = JSON.parse(this.cookieService.get('rememberMe'));
      if (!!rememberMe) {
        this.subscriptionService.subjectNext({ loginwithRememberMe: true });
      }
    }

    this.subService = this.subscriptionService.getSubject()
    .pipe(takeUntil(this.destroy$))
    .subscribe(val => {
      // if (val['refresh'] === true || val['singleCartDelete'] || val['info'] === 'cart delete all' || val['editCart']) {
      //   this.getQueryAndQueryparams();
      //   this.getCartCount();
      // }
      if (val['getUser']) {
        this.getUserDetails();
      }
      if (val['msg'] === "get shopping cart status bar data") {
        this.getCartCount();
      }
      if (val['categories']) {
        this.categories = val['categories'].filter(val => val['id'] !== -1);
      }
      if (val['control']) {
        if (this.product['product']['id'] === val['product']['product']['id']) {
          val['product']['msg'] = 1;
          this.cartProductIds = this.localStorageCartProd.map(el => { return el['product']['id'] });
          const index = this.cartProductIds.indexOf(val['product']['product']['id']);
          this.cartProductIds.splice(index, 1);
          this.product = val['product'];
        }
      }
      if (!!val['closeProducDialog'] && !!this.productDialogRef) {
        this.productDialogRef.close();
      }

    });
    if (window.innerWidth < 960) {
      this.sidenavOpen = false;
    }
    if (window.innerWidth > 960) {
      this.sidenavOpen = true;
    }
    if (window.innerWidth < 1280) {
      this.viewCol = 25;
    };
    if (localStorage.getItem('viewType')) {
      this.viewType = localStorage.getItem('viewType');
      this.viewCol = parseFloat(localStorage.getItem('viewCol'));
      this.viewColMob = (parseInt(localStorage.getItem('viewCol'), 10) === 33 || parseInt(localStorage.getItem('viewCol'), 10) === 25 || parseFloat(localStorage.getItem('viewCol')) === 25) ? 100 : parseInt(localStorage.getItem('viewCol'), 10);
      if (window.innerWidth < 960) {
        localStorage.setItem('viewCol', this.viewColMob.toString());
      }
    }
    if (this.activatedRoute.snapshot['data']['userDetails'] && this.activatedRoute.snapshot['data']['userDetails']['response']['status'] === 1) {
      this.userDetails = this.activatedRoute.snapshot['data']['userDetails']['response']['data']['users'];
      // if (this.featureTags["shipping_charge_applied_for_eligible_customer"]) {
      if (Object.keys(this.userDetails['cus_type_details']).length > 0) {
        this.storeDetails['delivery_fee'] = this.userDetails['cus_type_details']['delivery_fee'];
        this.storeDetails['delivery_upper_limit'] = this.userDetails['cus_type_details']['delivery_upper_limit'];
        this.storeDetails['rate_per_bottle'] = this.userDetails['cus_type_details']['rate_per_bottle'];
      }
      // }
      this.setCutOffTime(this.activatedRoute.snapshot['data']['userDetails']);
    }
    if (this.activatedRoute.snapshot['data']['store']) {
      this.storeDetails = this.activatedRoute.snapshot['data']['store']['response']['data']['store'];
      this.dateFormat = this.storeDetails['date_format'] === 'm/d/Y' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
    }
    this.loggedIn = this.apiService.loggedIn();
    this.loginSubService = this.apiService.getLogin()
    .pipe(takeUntil(this.destroy$))
    .subscribe(message => {
      if (message) {
        this.loggedIn = message['loggedIn'];
      }
    });
    if (JSON.parse(sessionStorage.getItem('cart')) !== null) {
      this.getLocalStorage();
    }
    this.getQueryAndQueryparams();
    this.getCategories();
    this.getBrands();
    // this.getCartCount();
    this.setSideNavMode();
    // this.title.setTitle('Store :: Hudson Milk + Market - Farmers Market on Wheels to Westchester, Putnam and Fairfield Counties');
    this.sharedDataService.productDialog$
    .pipe(takeUntil(this.destroy$))
    .subscribe(res =>{
      console.log(res);
      if(res){
        this.close();
      }
      
    })
  }

  getQueryAndQueryparams(sort: any = null) {

    try {


      // if (this.router.url.includes('all-products')) {      
      // if (this.router.url.includes('products')) {  
      if (this.router.url === '/products' ||  this.router.url.includes('/previously-ordered') ||(this.router.url.startsWith('/products') && this.router.url.includes('page'))
      ) {
        this.productsBasedOnCategory({});
      } else {
        var sortingValue = !!sessionStorage.getItem('sorting') ? JSON.parse(sessionStorage.getItem('sorting'))['value'] : !!this.storeDetails['sf_product_sorting'] ? this.storeDetails['sf_product_sorting'] : null;
        this.sub = this.activatedRoute.params
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
          this.params = params;
          if(!!this.featureTags && this.featureTags['ftag_sf_previously_ordered_products']){ 
            if(this.params.parentCategory == "previously-ordered"){
              this.productsBasedOnCategory({});
              return
            }
        }

          let condition = null
          condition = (params['parentCategory'] || params['subCategory'] || params['categoryName']) && params['categoryName'] !== 'search' || params['vendor_url']



          if (condition) {
            var catUrl = params['subCategory'] ? params['subCategory'] : params['parentCategory']
            if (isNaN(parseInt(catUrl))) {
              this.subscriptionService.subjectNext({ categorySearch: catUrl, cat_url: catUrl, title: true });
            }
            var query = {};
            if (checkDeliveryCalenderAndCutOffTime() === true) {
              query['edit_cart'] = 3;
            }
            if (isNaN(parseInt(params['subCategory'])) === false) {
              query['vendor_id'] = params['subCategory']
            } else {
              query['category_url'] = params['subCategory'] ? params['subCategory'] : params['parentCategory'];
              query['category_parent_url'] = params['parentCategory'];
            }

            // if (this.featureTags && this.featureTags["remove_vendor_code_in_url"]) {
            if (params && !!params['vendor_url'] && params['vendor_url'] !== '') {
              query['vendor_url'] = params['vendor_url'],
                delete query['vendor_id']
              delete query['category_url']
              delete query['category_parent_url']
            }
            // }
            this.page = this.pageParam;

            if (!!sortingValue) {
              query['sord'] = sortingValue
            }
            this.productsBasedOnCategory(query);
          }
        });
        this.sub = this.activatedRoute.queryParams
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
          this.queryParams = params;
          if (params['keyword'] || params['cat']) {
            var query = {}
            if (params['keyword'] !== '') {
              query['keyword'] = params['keyword']
            }
            if (params['cat'] !== undefined && params['cat'] !== "-1") {
              query['category_url'] = params['cat'];
              this.subscriptionService.subjectNext({ productSearch: params['cat'] });
            }
            if (checkDeliveryCalenderAndCutOffTime() === true) {
              query['edit_cart'] = 3;
            }
            // if(!!params['page']) {
            //   this.pageParam = params['page'];
            // } 
            // this.page =  !!this.pageParam ? this.pageParam : 1;
            if (this.page === '1' || this.page === 1) {
              this.router.navigate([], {
                relativeTo: this.activatedRoute, queryParams: { page: null },
                queryParamsHandling: "merge",
              });

            }
            query['page'] = this.page;
            query['limit'] = this.count || this.counts[0];
            if (!!sortingValue) {
              query['sord'] = sortingValue
            }
            this.pageLoaded = true;
            this.apiService.searchProducts(query)
            .pipe(takeUntil(this.destroy$))
            .subscribe(result => {
              if (isPlatformBrowser(this.platformId)) {
                this.pageLoaded = false;
              }
              this.subscriptionService.subjectNext({ setbreadcrumb: true });
              if (result['response']['status'] === 1 || result['response']['status'] === 6) {
                this.products = result['response']['data']['products']['products'];
                this.totalProductsCount = result['response']['data']['products']['count']
                if (query['category_url'] && !query['keyword']) {
                  this.categoryName = result['response']['data']['products']['title'];
                  this.categoryDescription = result['response']['status'] === 1 ? result['response']['data']['products']['description'] : '';
                  this.subCategories = result['response']['data']['products']['sub_categories'];
                  this.categoryWebsiteMessage = result['response']['data']['products']['cat_web_msg'] ? result['response']['data']['products']['cat_web_msg'] : undefined;
                }
              } else if (result['response']['status'] === 404) {
                this.router.navigateByUrl('**', { skipLocationChange: true });
              }
              this.productNotAvailable = (this.products.length === 0 && this.subCategories.length === 0) ? true : false;
              this.pageLoaded = false;
            }, (error) => {
              this.pageLoaded = false;
              this.notFoundRedirect(error);
              return of(null); // In SSR, Prevent memory leaks by returning a safe value

            });
          }
        });
      }

      // if(this.params['name'] === undefined && this.params['categoryName'] === undefined && this.queryParams['keyword'] === undefined)  {
      //   this.getCategories();
      // }
    } catch (error) {
      console.log(error)
    }
  }
  notFoundRedirect(error) {
      this.pageLoaded = false;
      if (error) {
        console.log(error);
        if (error['status'] === 404) {
          this.router.navigateByUrl('**', { skipLocationChange: true });
        }
      }
  }
  ngAfterViewInit() {
    this.swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      }
    }
  }
  getUserDetails() {
    if(isPlatformBrowser(this.platformId)){
    this.apiService.getAutheticatedUserDetails()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data['response']['status'] === 1) {
        this.userDetails = data['response']['data']['users'];
        // if (this.featureTags["shipping_charge_applied_for_eligible_customer"]) {
        if (Object.keys(this.userDetails['cus_type_details']).length > 0) {
          this.storeDetails['delivery_fee'] = this.userDetails['cus_type_details']['delivery_fee'];
          this.storeDetails['delivery_upper_limit'] = this.userDetails['cus_type_details']['delivery_upper_limit'];
          this.storeDetails['rate_per_bottle'] = this.userDetails['cus_type_details']['rate_per_bottle'];
        }
        // }
        this.setCutOffTime(data);
      }
    }, err => { })
  }
  }
  setCutOffTime(data) {
    var cutOffTime = [{
      storeCutOffTime: data['response']['data']['store_date_time']['date'],
      currentDateAndtime: data['response']['data']['current_date_time']['date'],
      orderDeliveryDate: data['response']['data']['delivery_date'],
      storeDeliveryDate: data['response']['data']['store_delivery_date']
    }];
    if (data['response']['data']['store_delivery_date'] !== null) {
      sessionStorage.setItem('cutoff', JSON.stringify(cutOffTime));
    }
    this.current_date_time = data['response']['data']['current_date_time']['date'];
    let booking_start_date = data['response']['data']['booking_start_date'];
    if (booking_start_date) {
      sessionStorage.setItem('booking_start_date', JSON.stringify(booking_start_date));
    }
  }
  getCategories() {
    this.apiService.categories()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        this.categories = result['response']['data']['cat_list'];
      }
    }, (error) => {
      if (error) {
        console.log(error);
        return of(null); // In SSR, Prevent memory leaks by returning a safe value
      }
    });
  }
  productsBasedOnCategory(query) {
    if(!!this.featureTags && this.featureTags['sf_seo']){    
      localStorage.removeItem('Beforepagination');
    }
    if (this.page === '1' || this.page === 1) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute, queryParams: { page: null },
        queryParamsHandling: "merge",
      });
    }
    if (query['category_url']) {
      this.existPCat = query['category_url'];
    }
    if (!query['vendor_id']) {
      this.setSelectedVendorValue(0);
    } else if (query['vendor_id']) {
      this.setSelectedVendorValue(parseInt(query['vendor_id']));
    }

    if(this.router.url === '/products'){
      query['type'] = 'all_products';
    }
    if(!!this.featureTags && this.featureTags['ftag_sf_previously_ordered_products']){ 
      if(this.router.url.includes('/previously-ordered')){
        query['type'] = 'previously_ordered';
        this.previosulyOrdered = "yes";
        query['previously_ordered'] = this.previosulyOrdered;
        if (checkDeliveryCalenderAndCutOffTime() === true) {
          query['edit_cart'] = 3; 
        }
      }
    }
    var sortingValue = !!sessionStorage.getItem('sorting') ? JSON.parse(sessionStorage.getItem('sorting'))['value'] : !!this.storeDetails['sf_product_sorting'] ? this.storeDetails['sf_product_sorting'] : null;
    if (!!sortingValue) {
      query['sord'] = sortingValue;
    }
    query['page'] = this.page;
    query['limit'] = !!JSON.parse(localStorage.getItem('pageCount')) ? JSON.parse(localStorage.getItem('pageCount'))['count'] : this.counts[0];
    this.pageLoaded = true;
    if(!!this.featureTags && this.featureTags['sf_seo']){
      localStorage.removeItem('Afterpagination');      
    }
    if (!!this.featureTags && this.featureTags['ftag_sf_manufacturer_list']) {
      if ('vendor_url' in query) {
        query['manufacturer_url'] = query['vendor_url'];
        delete query['vendor_url'];
      }
    }
    this.apiService.getProductsBasedOnCategory(query)
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (isPlatformBrowser(this.platformId)) {
        this.pageLoaded = false;
      }
      this.subscriptionService.subjectNext({ setbreadcrumb: true });
      if (!!result && result['response']['status'] === 1 || result['response']['status'] === 6) {
        this.products = result['response']['data']['products']['products'];
        this.categoryDescription = result['response']['status'] === 1 ? result['response']['data']['products']['description'] : '';
        this.categoryName = result['response']['data']['products']['title'];
        this.subCategories = result['response']['data']['products']['sub_categories'];
        this.totalProductsCount = this.subCategories.length > 0 ? result['response']['data']['products']['count'] + result['response']['data']['products']['sub_categories'].map(item => item.count).reduce((prev, next) => prev + next) : result['response']['data']['products']['count'];
        this.totalProductsCount = result['response']['data']['products']['count']

        // this.products = this.products.concat(...this.subCategories.map(({products}) => products || []));
        this.categoryWebsiteMessage = result['response']['data']['products']['cat_web_msg'] ? result['response']['data']['products']['cat_web_msg'] : undefined;
      } else if (result['response']['status'] === 404) {
        this.router.navigateByUrl('**', { skipLocationChange: true });
      }
      else {
        this.categoryDescription = '';
      }
      this.productNotAvailable = (this.products.length === 0 && this.subCategories.length === 0) ? true : false;
      this.pageLoaded = false;
    }, (error) => {
      this.notFoundRedirect(error);
      this.pageLoaded = false;
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    });
  }
  public getBrands() {
    this.apiService.getVendor()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        this.brands = result['response']['data']['vendor_list'];
        //Current Vendor Info
        if (this.params && this.params.subCategory) {
          var supplier_info_tmp = Object.entries(this.brands).find(([key, value]) => value['id'] == this.params['subCategory']);
          this.supplier_info = supplier_info_tmp ? supplier_info_tmp[1] : {};
        }

        if (this.params && this.params["vendor_url"]) {
          let vendor = Object.entries(this.brands).find(
            ([key, value]) => {
              return (
                value["vendor_url"] === this.params["vendor_url"]
              );
            }
          );
          this.supplier_info = vendor ? vendor[1] : {};
        }
        if (this.supplier_info && this.supplier_info['vendor_description']) {
          this.sanitizedDescription = this.sanitizer.bypassSecurityTrustHtml(this.supplier_info['vendor_description']);
        }

        this.subscriptionService.subjectNext({ vendors: result['response']['data']['vendor_list'] });
      }
    }, (error) => {
      console.log(error);
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    });
  }
  brandSelection(brand) {
    this.setSelectedVendorValue(brand['id']);
    this.router.navigate(['/vendors', brand['vendor_name'].replace(/[\s&/]+/g, '_'), brand['id']])
    this.subscriptionService.subjectNext({ vendorName: brand['vendor_name'], vendors: this.brands });

    setTimeout(() => {
      this.getBrands();
    }, 50);
    if (!this.sidenavOpen)
      this.sidenav.close();
  }
  setSelectedVendorValue(value) {
    this.brands.forEach(x => { x.selected = x.id !== value ? false : true });

  }
  ngOnDestroy() {
    !!this.sub && this.sub.unsubscribe();
    !!this.loginSubService && this.loginSubService.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    (window.innerWidth < 960) ? this.sidenavOpen = false : this.sidenavOpen = true;
    (window.innerWidth < 960) ? this.viewColMob = 100 : this.viewColMob = 50;
    (window.innerWidth > 960) ? this.viewCol = 25 : this.viewCol = 25;
    localStorage.setItem('viewType', 'grid');
    if (window.innerWidth < 960) {
      localStorage.setItem('viewCol', this.viewColMob.toString());
    }
    if (window.innerWidth > 960) {
      localStorage.setItem('viewCol', this.viewCol.toString());
    }
    this.setSideNavMode();
  }

  setSideNavMode() {
    setTimeout(() => {
      this.sidenavMode = this.sidenavOpen ? 'side' : 'over';
    }, 0);
  }

  public changeCount(count) {
    this.count = count;
    localStorage.setItem('pageCount', JSON.stringify({ count: count }));
    this.router.navigate([], {
      relativeTo: this.activatedRoute, queryParams: { page: null },
      queryParamsHandling: "merge",
    });
    this.page = 1;
    if (this.featureTags && this.featureTags["sf_multiple_api_call"]) {
      this.refreshCategory();
    }else{
      this.getQueryAndQueryparams();
    }

  }

  public changeSorting(sort) {
    this.sort = sort;
  }

  public changeViewType(viewType, viewCol) {

    localStorage.setItem('viewType', viewType);
    if (window.innerWidth > 960) {
      localStorage.setItem('viewCol', viewCol);
    }
    if (window.innerWidth < 960) {
      this.viewColMob = viewCol === 25 ? 50 : 100;
      localStorage.setItem('viewCol', this.viewColMob.toString());
    }
    this.viewType = localStorage.getItem('viewType');
    this.viewCol = parseInt(localStorage.getItem('viewCol'), 10);
  }

  public openProductDialog(product) {
    product['storeDetails'] = this.storeDetails;
    // product['images'] = [{medium: product['product']['product_image1']}]
    // if(!!product['product']['product_image2'] && product['product']['product_image2'] !== "null") {
    //   product['images'][1] = {medium: product['product']['product_image2']};
    // }
    // if (this.featureTags && this.featureTags['supplier_details_tab_product_page']) {
    const parser = new DOMParser();
    const doc2 = parser.parseFromString(product['product']['website_description'], 'text/html');
    const doc = parser.parseFromString(product['product']['website_description'], 'text/html');
    this.productTabs = [];
    if (doc) {
      doc.querySelectorAll('[role="tab"]').forEach(tabheader => {
        var Tabid = tabheader.getAttribute('aria-controls');
        this.productTabs.push({
          'header': tabheader.innerHTML,
          'Tabid': Tabid
        })
      });
      if (this.productTabs.length > 0) {
        this.productTabs.forEach((tabbody, key) => {
          var TabContent = doc.getElementById(tabbody.Tabid.toString()).innerHTML;
          this.productTabs[key]['TabContent'] = TabContent;
        });
        var HtmlDiv = doc2.querySelector('[role="tabpanel"]');
        HtmlDiv.remove();
      }
      this.productDescription = doc2.body.textContent ? doc2.body.textContent : "";
    }
    // }
        if(!!this.featureTags && this.featureTags['ftag_product_images_related_issues']){
          const images: { medium: string }[] = [];
          for (let i = 1; i <= 5; i++) {
            const imageKey = `product_image${i}` as keyof typeof product['product'];
            const imageValue = product['product'][imageKey];

            if (imageValue) {
              images.push({ medium: imageValue });
            }
          }
          product['images'] = images.length > 0 ? images : [{ medium: '' }];

        }else{
          product['images'] = !!product['product']['product_image1'] && !!product['product']['product_image2'] ? [{ medium: product['product']['product_image1'] }, { medium: product['product']['product_image2'] }] :
          !!product['product']['product_image1'] && !!product['product']['product_image2'] === false ? [{ medium: product['product']['product_image1'] }] :
            !!product['product']['product_image1'] === false && !!product['product']['product_image2'] ? [{ medium: product['product']['product_image2'] }] : [{ medium: '' }];
        }
        if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
          this.productDialogRef = this.dialog.open(this.productDialog, {
            minWidth: '80vw',
            data: product,      
            panelClass: 'product-dialog-quick-view',
            direction: (this.settings.rtl) ? 'rtl' : 'ltr'
          });
        } else {
          this.productDialogRef = this.dialog.open(this.productDialog, {
            minWidth: '80vw',
            data: product,
            panelClass: 'product-dialog',
            direction: (this.settings.rtl) ? 'rtl' : 'ltr'
          });
        }
        let query = {};
        if (this.featureTags && this.featureTags['ftag_sf_manufacturer_list']) {
          query = {
            website_url: product['product']['website_url']
          };
        }else{
          query = {
            website_url: product['product']['id']
          };
        }
    this.pageLoaded = true;
    this.apiService.searchProducts(query)
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        this.product = result['response']['data']['products']['products'][0];
        // if (this.featureTags && this.featureTags['supplier_details_tab_product_page']) {
        // Product Description 
        const parser = new DOMParser();
        const doc2 = parser.parseFromString(this.product['product']['website_description'], 'text/html');
        const doc = parser.parseFromString(this.product['product']['website_description'], 'text/html');
        if (doc) {
          doc.querySelectorAll('[role="tab"]').forEach(tabheader => {
            var Tabid = tabheader.getAttribute('aria-controls');
            this.productTabs.push({
              'header': tabheader.innerHTML,
              'Tabid': Tabid
            })
          });
          if (this.productTabs.length > 0) {
            this.productTabs.forEach((tabbody, key) => {
              var TabContent = doc.getElementById(tabbody.Tabid.toString()).innerHTML;
              this.productTabs[key]['TabContent'] = TabContent;
            });
            var HtmlDiv = doc2.querySelector('[role="tabpanel"]');
            HtmlDiv.remove();
          }
          this.productDescription = doc2.body.textContent ? doc2.body.textContent : "";
        }
        // }

        this.product['storeDetails'] = this.storeDetails;
        this.title.setTitle(`${this.product['product']['description']} - ${this.title.getTitle()}`);
        if (this.product['product']['meta_description']) {
          this.meta.updateTag({ name: 'description', content: this.product['product']['meta_description'] });
        }
        this.subscription.subjectNext({ setbreadcrumb: true, productName: this.product['product']['description'] });
        // this.product['images'] = [{medium: this.product['product']['product_code'] }];
        this.zoomImage = this.product['product']['product_image1'];
        this.thumbImage = !!this.product['product']['product_image1'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image1'].split('.')[0]}_md.${this.product['product']['product_image1'].split('.')[1]}` : 'assets/images/no_image_found_md.png';
        this.fullImage = !!this.product['product']['product_image1'] ? `${this.imageUrl}${this.storeDetails['id']}/original/${this.product['product']['product_image1'].split('.')[0]}.${this.product['product']['product_image1'].split('.')[1]}` :
          !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? `${this.imageUrl}${this.storeDetails['id']}/original/${this.product['product']['product_image2'].split('.')[0]}.${this.product['product']['product_image2'].split('.')[1]}` :
            'assets/images/no_image_found_md.png';
        this.mainImage = !!this.product['product']['product_image1'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image1'].split('.')[0]}_lg.${this.product['product']['product_image1'].split('.')[1]}` :
          !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image2'].split('.')[0]}_lg.${this.product['product']['product_image2'].split('.')[1]}` :
            'assets/images/no_image_found_md.png';
        this.mainImageName = !!this.product['product']['product_image1'] ? this.product['product']['product_image1'] :
          !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? this.product['product']['product_image2'] : 'assets/images/no_image_found_md.png';
        this.product['secImages'] = !!this.product['product']['product_image1'] && !!this.product['product']['product_image2'] ? [{ medium: this.product['product']['product_image1'] }, { medium: this.product['product']['product_image2'] }] :
          !!this.product['product']['product_image1'] && !!this.product['product']['product_image2'] === false ? [{ medium: this.product['product']['product_image1'] }] :
            !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? [{ medium: this.product['product']['product_image2'] }] : [];

      } else if (result['response']['status'] === 404) {
        this.router.navigateByUrl('**', { skipLocationChange: true });
      }
      this.pageLoaded = false;
    }, (error) => {
      if (error) {
        console.log(error);
        if (isPlatformBrowser(this.platformId) && error['status'] === 404) {
          this.router.navigateByUrl('**', { skipLocationChange: true });
        }
        this.pageLoaded = false;
      }
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    });
    this.productDialogRef.afterClosed()
    .pipe(takeUntil(this.destroy$))
    .subscribe(product => {
      if (product && this.loggedIn === true) {
        this.router.navigate(['/products', product['product']['id']]);
      } else if (this.loggedIn === false) {
        this.getLocalStorage();
        this.getCartCount();

      }
    });
  }
  public onPageChanged(event) {
    this.page = event;
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: { page: event === 1 ? null : event },
        queryParamsHandling: "merge", // remove to replace all query params by provided
      }
    );
    this.getQueryAndQueryparams();
  }

  public onChangeCategory(event) {
    this.page = 1;
    if (event['event'].target) {
      const index = this.categories.findIndex(val => val['category_url'] === event.category['category_url'])
      this.category = index >= 0 ? this.categories.filter(val => val['category_url'] === event.category['category_url']) :
        this.categories.reduce((arr, item) => arr.concat(item.sub_list), []).find(sub => sub.category_url === event.category['category_url']);
    }
    if (!this.sidenavOpen) {
      this.sidenav.close();
    }
  }


  /** Shopping Cart Status Bar Start */
  getSaleOrderDetails() {
    this.apiService.getSaleOrders()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data['response']['status'] === 1) {
        let resData = data['response']['data'];
        let undeliveredOrder = resData['undelivered_order'];
        let saleOrderItems = undeliveredOrder[0] && undeliveredOrder[0]['sale_order_items'];
        let totalPayable = undeliveredOrder[0] && undeliveredOrder[0]['total_payable'];
        // if (this.featureTags['taxes_in_storefront']) {
        this.totalTaxCollectedAmount = undeliveredOrder[0]['tax_collected'];
        // }
        this.calculateCartData(saleOrderItems, totalPayable);
      }
    });
  }


  getRecurringDetails(cartProduct: Array<object>, notCartProduct: Array<object>, notCartProductIds: Array<number>) {
    this.apiService.getRecurring()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data['response']['status'] === 1) {
        let recurringItems = data['response']['data']['recurring_products'];
        let recurringProducts = recurringItems.filter(product => {
          let productIndex = notCartProduct.filter(val => val !== undefined)
            .findIndex(el => el['product']['id'] === product['product_id']);
          if (this.datePipe.transform(product['delivery_date'], 'yyyy-MM-dd') === product['recurring_date'] ||
            notCartProductIds.indexOf(product['product']['id']) >= 0) {
            if (productIndex >= 0 && notCartProduct[productIndex] !== undefined) {
              product['recurring_date'] = product['delivery_date'];
              product['quantity'] = notCartProduct[productIndex]['quantity'];
              product['frequency'] = notCartProduct[productIndex]['frequency'];
              product['cartId'] = notCartProduct[productIndex]['id'];
              product['extended_price'] = notCartProduct[productIndex]['extendedprice'];
            }
            return product;
          }
        });
        let concatedArray = cartProduct.concat(recurringProducts);
        this.calculateCartData(concatedArray);
      }
    });
  }

  getCartCount() {
    if (this.apiService.loggedIn()) {
      if (checkDeliveryCalendarOrderStatus("undelivered") &&
        (checkCutoffDate('!==') || checkCutoffDate('===') && checkCutoffTime('<'))) {
        this.getSaleOrderDetails();
      } else if (checkDeliveryCalenderAndCutOffTime() === true) {
        this.getSaleOrderDetails();
      } else {
        // this.getCartDetails();
        this.getSaleOrderDetails();
      }

    } else {
      let cartProduct = JSON.parse(sessionStorage.getItem('cart'));
      this.calculateCartData(cartProduct);
    }
  }
  /** End */

  /* Calculate Cart Count Data Start */
  calculateCartData(data: Array<Object>, total?: any) {
    let bottleQty = 0;
    let totalBottlePrice = 0;
    let subTotal = 0;
    let totalItems = !!data ? data.length : 0;

    data && data.length > 0 && data.forEach(product => {
      let uom = product['product']['cb_unit_of_measurement']['uom_reference_id'];
      let quantity = uom === 1 ? parseFloat(product['quantity']) : parseInt(product['quantity']);
      // totalQuantity += quantity;
      if (!!total === false) {
        if (!!product['bottleQty'])
          bottleQty += parseInt(product['bottleQty']);
        else if (product['product']['bottle_charge']) {
          bottleQty += parseInt(product['quantity']);
        }
        if (!!product['extended_price']) {
          // let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit' ?  this.decimalPipe.transform(this.decimalPipe.transform((product['product']['sell_in_conv_rate'] * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(product['extended_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
          subTotal += parseFloat(this.decimalPipe.transform(this.decimalPipe.transform(product['extended_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, ''));
          // subTotal += parseFloat(productPrice);        
        } else if (!!product['extendedprice']) {
          if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
            let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit' ? this.decimalPipe.transform(this.decimalPipe.transform((product['product']['sell_in_conv_rate'] * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(product['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
            subTotal += parseFloat(productPrice);
          }else{
            let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'nos' ? this.decimalPipe.transform(this.decimalPipe.transform((product['product']['sell_in_conv_rate'] * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(product['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
          subTotal += parseFloat(productPrice);
          }
        } else {
          if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
            let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit' ? this.decimalPipe.transform(this.decimalPipe.transform((parseFloat(product['product']['sell_in_conv_rate']) * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform((quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
            subTotal += parseFloat(productPrice);
          }else{
            let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'nos' ? this.decimalPipe.transform(this.decimalPipe.transform((parseFloat(product['product']['sell_in_conv_rate']) * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform((quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
          subTotal += parseFloat(productPrice);
          }
        }
      }
    });

    if (!!total === false) {
      totalBottlePrice = bottleQty * this.storeDetails['rate_per_bottle'];
      let storeDeliveryFee = this.storeDetails['delivery_fee'];
      let deliveryUpperLimit = this.storeDetails['delivery_upper_limit'];
      let deliveryFee = subTotal >= deliveryUpperLimit && deliveryUpperLimit > 0 ? 0 : storeDeliveryFee;
      total = totalBottlePrice + subTotal + deliveryFee;
      // if (this.featureTags['taxes_in_storefront']) {
      if (this.totalTaxCollectedAmount > 0) {
        total = total + this.totalTaxCollectedAmount;
      }
      // }
    }
    this.shoppingCartStatusBarData = { items: totalItems, total: totalItems > 0 ? total : 0 };
    // if (this.apiService.loggedIn()) {
    this.sharedDataService.cartDataSource.next(this.shoppingCartStatusBarData);
    // }
    // console.log('calculateCartData', this.shoppingCartStatusBarData)
    // console.log('calculateCartData Test', bottleQty, totalBottlePrice, subTotal,total)
  }
  /* End */

  public addToCart(product) {
    // if check allow to create order (OR) add product start
    if (this.apiService.loggedIn()) {
      if (!isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, { yesBtn: true, noBtn: true })) {
        return;
      }
    }
    // if check allow to create order (OR) add product end

    product['msg'] = 2;
    product['storeDetails'] = this.storeDetails;
    const dialogRef = this.dialog.open(CartDialogComponent, {
      width: '450px',
      panelClass: 'product-dialog',
      data: product
    });
    dialogRef.afterClosed()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result) {
        if (result['value'] === 'confirm' && result['logged'] === 'no') {
          this.getLocalStorage();
          this.getCartCount();
        }
        if (result['value'] === 'confirm' && result['logged'] === 'yes') {
          this.getCartCount();
          this.getQueryAndQueryparams();
        }
      }
    });
  }
  editCart(product) {
    // if check allow to create order (OR) add product start
    if (this.apiService.loggedIn()) {
      if (!isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, { yesBtn: true, noBtn: false })) {
        return;
      }
    }
    // if check allow to create order (OR) add product end
    var value;
    if (this.loggedIn === true) {
      product['msg'] = 2;
      value = product
    }
    if (this.loggedIn === false) {
      const cartData = JSON.parse(sessionStorage.getItem('cart'));
      var newproductValue = cartData.filter(val => val['product']['id'] === product['product']['id']);
      value = {};
      newproductValue[0]['msg'] = 1
      value = newproductValue[0];
    }
    value['storeDetails'] = this.storeDetails;

    const dialogRef = this.dialog.open(CartDialogComponent, {
      width: '450px',
      panelClass: 'product-dialog',
      data: value
    });
    dialogRef.afterClosed()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result) {
        if (result['value'] === 'confirm' && result['logged'] === 'no') {
          this.getLocalStorage();
          this.getCartCount();
        }
        if (result['value'] === 'confirm' && result['logged'] === 'yes') {
          this.getCartCount();
          // this.getQueryAndQueryparams();
        }
      }
    });
  }
  recurring(product) {
    // if check allow to create order (OR) add product start
    if (this.apiService.loggedIn()) {
      if (!isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, { yesBtn: true, noBtn: false })) {
        return;
      }
    }
    // if check allow to create order (OR) add product end
    product['msg'] = 2;
    product['currency'] = this.storeDetails['currency'];
    product['deliveryDay'] = this.userDetails['delivery_day'];
    product['date-format'] = this.dateFormat;
    const dialogRef = this.dialog.open(PopupComponent, {
      maxWidth: '95vw',
      width: '360px',
      panelClass: 'product-dialog',
      data: {
        data: product,
        msg: 'edit subscription from products'
      }
    });
  }
  public openCartDialog(event) {
    this.onOpenProductDialog.emit(event);
  }

  getLocalStorage() {
    this.localStorageCartProd = JSON.parse(sessionStorage.getItem('cart'));
    this.cartProductIds = !!this.localStorageCartProd ? this.localStorageCartProd.map(val => { return val['product']['id'] }) : undefined;
  }
  goToCart() {
    this.router.navigate(['cart']);
    // this.apiService.sendEvent(true);
  }
  close(): void {
    if (this.productDialogRef) {
      this.productDialogRef.close();
    }
  }
  goToProduct(product, value) {
    var description = product['product']['description'].replace('&amp;', '&');
    if (this.router.url.includes('categories')) {
      var parentCategory = this.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);

      if (!!parentCategory === false) {
        var parent = this.categories.find(val => {
          return val['sub_list'].some(sub => {
            return sub['category_url'] === product['product']['cb_category']['url']
          });
        });
        if (product['product']['website_url']) {
          // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']]);
          this.router.navigate(['/products', product['product']['website_url']]);
        } else {
          // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']]);
          this.router.navigate(['/products', product['product']['id']]);
        }
      } else {
        if (product['product']['website_url']) {
          // this.router.navigate(['/categories', parentCategory['category_url'], product['product']['website_url']]);
          this.router.navigate(['/products', product['product']['website_url']]);
        } else {
          // this.router.navigate(['/categories', parentCategory['category_url'], product['product']['id']]);
          this.router.navigate(['/products', product['product']['id']]);
        }
      }
    } else if (this.router.url.includes('vendors')) {
      // if (this.featureTags['enable_individual_products_page']) {
      var parentCategory = this.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);
      if (!!parentCategory === false) {
        var parent = this.categories.find(val => {
          return val['sub_list'].some(sub => {
            return sub['category_url'] === product['product']['cb_category']['url']
          });
        });
        if (product['product']['website_url']) {
          // this.router.navigate(['/vendors', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']]);
          this.router.navigate(['/products', product['product']['website_url']]);
        } else {
          // this.router.navigate(['/vendors', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']]);
          this.router.navigate(['/products', product['product']['id']]);

        }
      } else {
        if (product['product']['website_url']) {
          // this.router.navigate(['/categories', parentCategory['category_url'], product['product']['website_url']]);
          this.router.navigate(['/products', product['product']['website_url']]);
        } else {
          // this.router.navigate(['/categories', parentCategory['category_url'], product['product']['id']]);
          this.router.navigate(['/products', product['product']['id']]);
        }
      }

      // } else if (this.router.url.includes('search') || this.router.url.includes('all-products')) {
    } else if (this.router.url.includes('search') || this.router.url.includes('products')  || this.router.url.includes('previously-ordered')) {
      if (product['product']['website_url']) {
        this.router.navigate(['/products', product['product']['website_url']]);
      } else {
        this.router.navigate(['/products', product['product']['id']]);
      }
    }else if (this.router.url.includes('producers')) {
      var parentCategory = this.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);
      if (!!parentCategory === false) {
        var parent = this.categories.find(val => {
          return val['sub_list'].some(sub => {
            return sub['category_url'] === product['product']['cb_category']['url']
          });
        });
        if (product['product']['website_url']) {
          this.router.navigate(['/products', product['product']['website_url']]);
        } else {
          this.router.navigate(['/products', product['product']['id']]);

        }
      } else {
        if (product['product']['website_url']) {
          this.router.navigate(['/products', product['product']['website_url']]);
        } else {
          this.router.navigate(['/products', product['product']['id']]);
        }
      }

    }

    // if(value === 'subCat' && this.router.url.split('/').length === 4 && this.router.url.includes('categories')) {
    //   this.router.navigate(['/categories', this.params['parentCategory'], this.params['subCategory'] , description.replace(/[\s&()%/]+/g, '-') , product['product']['id']]);
    // } else if (value === 'parent' && this.router.url.includes('categories')) {
    //   if(this.router.url.split('/').length > 4) {
    //     this.router.navigate(['/categories', this.params['parentCategory'], this.params['subCategory'], description.replace(/[\s&()%/]+/g, '-') , product['product']['id']]);
    //   } else {
    //     this.router.navigate(['/categories', this.params['parentCategory'], description.replace(/[\s&()%/]+/g, '-') , product['product']['id']]);
    //   }
    // } 
  }
  setFont() {
    if (window.innerWidth < 600 && this.viewColMob === 50) {
      let styles = {
        'font-size': '12px',
        'padding-left': '0px'
      }
      return styles;
    }

  }
  changeSort(event, value) {
    this.selectedSorting = value;
    value['selected'] = true;
    // this.sortingOptions = this.sortingOptions.filter(val => {
    //   val['selected'] = value['value'] === val['value'] ? true: false;
    //   return val;
    // });
    sessionStorage.setItem('sorting', JSON.stringify(value));
    this.selectedSortingValue(value['value']);
    this.refreshCategory();
    //this.getQueryAndQueryparams();

  }
  selectedSortingValue(item) {
    if(!!this.featureTags && this.featureTags['ftag_sf_previously_ordered_products']){ 
        const urlPath = this.router.url;
        const updatedSortingOptions = [...this.sortingOptions];
        const storedSorting = JSON.parse(sessionStorage.getItem('sorting') || '{}');
        
      if (urlPath.includes('/previously-ordered')) {
      
        const previouslyOrderedOption = updatedSortingOptions.find(option => option.value === 'popularity');
      
        
        if (previouslyOrderedOption) {
          // Check if stored sorting matches and is selected
          if (storedSorting.value === 'popularity' && storedSorting.selected) {
            previouslyOrderedOption.display = 'Sort by Most Purchased';
            previouslyOrderedOption.value = 'mostpurchased';
            previouslyOrderedOption.selected = true;  
          } else {
            previouslyOrderedOption.display = 'Sort by Most Purchased';
            previouslyOrderedOption.value = 'mostpurchased';
            // Keep previouslyOrdered unselected
          }
        }
        
        
      } else {
      
        const defaultOption = updatedSortingOptions.find(option => option.value === 'mostPurchased');
        if (defaultOption) {
          defaultOption.display = 'Sort by popularity';
          defaultOption.value = 'popularity';
        }
        
      }
      this.sortingOptions = updatedSortingOptions; 
    }
    item = item.toLowerCase();
    this.sortingOptions = this.sortingOptions.filter(val => {
      val['selected'] = item === val['value'] ? true : false;
      if (item === val['value']) {
        this.selectedSorting = val;
      }
      return val;
    });
  }

  public scrollToTop() {
    // Ensure this code only runs in the browser
    if(!!this.featureTags && this.featureTags['sf_mobile_view_issue']){
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    }else{
      if (isPlatformBrowser(this.platformId)) {
        const contentContainer = document.querySelector(".mat-sidenav-content");
        if (contentContainer) {
          contentContainer.scroll({ top: 0, left: 0, behavior: "smooth" });
        } else {
          window.scroll({ top: 0, left: 0, behavior: "smooth" });
        }
      }
    }
  }
  getRouterLink(product: any): any[] {
    if (product['product']['website_url']) {
      return ['/products', product['product']['website_url']];
    } else {
      return ['/products', product['product']['id']];
    }
  }
  // var desp=product['product']['description'].toLowerCase();
  // var subCat=product['product']['cb_category']['url'].toLowerCase();
  // // if (product['product']['website_url']) {
  // //   return this.chkCategory ?
  // //     [product['product']['website_url'].replace(/[\s&()%/]+/g, '_')] :
  // //     [subCat.replace(/[\s&()%/]+/g, '_'), product['product']['website_url'].replace(/[\s&()%/]+/g, '_')];
  // // } else {
  // //   return this.chkCategory ?
  // //     [product['product']['id']] :
  // //     [subCat.replace(/[\s&()%/]+/g, '_'), product['product']['id']];
  // // }
  // if (this.router.url.includes('categories')) {
  //   var parentCategory = this.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);

  //   if (!!parentCategory === false) {
  //     var parent = this.categories.find(val => {
  //       return val['sub_list'].some(sub => {
  //         return sub['category_url'] === product['product']['cb_category']['url']
  //       });
  //     });
  //     if (product['product']['website_url']) {
  //       // return['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']];
  //       return['/products', product['product']['website_url']];
  //     } else {
  //       // return['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']];
  //       return['/products', product['product']['id']];
  //     }
  //   } else {
  //     if (product['product']['website_url']) {
  //     // return['/categories', parentCategory['category_url'], product['product']['website_url']];
  //     return['/products', product['product']['website_url']];

  //     }else{
  //     return['/products', product['product']['id']];
  //   }
  //   }
  // } else if (this.router.url.includes('vendors')) {
  //   if(this.featureTags['enable_individual_products_page']){
  //     var parentCategory = this.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);
  //     if (!!parentCategory === false) {
  //       var parent = this.categories.find(val => {
  //         return val['sub_list'].some(sub => {
  //           return sub['category_url'] === product['product']['cb_category']['url']
  //         });
  //       });
  //       if (product['product']['website_url']) {
  //         // return['/vendors', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']];
  //         return['/products',  product['product']['website_url']];
  //       } else {
  //         // return['/vendors', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']];
  //         return['/products',  product['product']['id']];
  //       }  
  //   }
  //   } else {
  //     if (product['product']['website_url']) {
  //       // return['/vendors', this.params['parentCategory'], this.params['subCategory'], product['product']['website_url']];
  //       return['/products', product['product']['website_url']];
  //     } else {
  //       // return['/vendors', this.params['parentCategory'], this.params['subCategory'], product['product']['id']];
  //       return['/products',product['product']['id']];
  //     }
  //   }      
  // }
  // }

  generateHref(product: any): string {
    const urlTree = this.router.createUrlTree(this.getRouterLink(product));
    return this.router.serializeUrl(urlTree);
  }
  onLinkClick(event: MouseEvent, product: any): void {
    // Allow default behavior for middle-click or Ctrl+Click
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }

    // Prevent default behavior for regular clicks
    event.preventDefault();

    // Your custom navigation logic
    this.goToProduct(product, 'parent');

  }
  getUrl(product) {
    if (product) {
      var desp = product['product']['description'].toLowerCase();
      if (product['product']['website_url']) {
        return ['/products/', product['product']['website_url']]
      } else {
        return ['/products/', product['product']['id']];
      }
    }
  }
  // This method updates the cart data
  // updateCartData(newData: { items: number; total: number }) {
  //   this.shoppingCartStatusBarData = newData;
  // }


  // clearQueryParams() {
  //   // Navigate to the same route and reset query parameters
  //   this.router.navigate([], {
  //     queryParams: {}, // Clear query parameters
  //     relativeTo: this.activatedRoute // Keep the current route context
  //   });
  // }

  refreshCategory() {
    // Check if the current URL is for products or contains pagination
    if (this.router.url === '/products' || (this.router.url.startsWith('/products') && this.router.url.includes('page')) || this.router.url.includes('/previously-ordered')) {
      // If true, fetch products based on the default category
      this.productsBasedOnCategory({});
    } else {
      // Get the sorting value from sessionStorage or from storeDetails
      var sortingValue = !!sessionStorage.getItem('sorting') ? JSON.parse(sessionStorage.getItem('sorting'))['value'] : !!this.storeDetails['sf_product_sorting'] ? this.storeDetails['sf_product_sorting'] : null;

      // Retrieve route parameters
      let params = this.activatedRoute.snapshot.params;

      // Determine if we need to fetch products based on category or vendor URL
      let condition = (params['parentCategory'] || params['subCategory'] || params['categoryName']) && params['categoryName'] !== 'search' || params['vendor_url'];

      if (condition) {
        // Set category URL based on the presence of subCategory or parentCategory
        var catUrl = params['subCategory'] ? params['subCategory'] : params['parentCategory'];
        if (isNaN(parseInt(catUrl))) {
          // Notify subscription service about category search
          this.subscriptionService.subjectNext({ categorySearch: catUrl, cat_url: catUrl, title: true });
        }

        var query = {};
        // Check if delivery calendar and cutoff time are valid
        if (checkDeliveryCalenderAndCutOffTime() === true) {
          query['edit_cart'] = 3; // Modify cart for delivery
        }

        // Determine if the subCategory is a number
        if (!isNaN(parseInt(params['subCategory']))) {
          query['vendor_id'] = params['subCategory'];
        } else {
          query['category_url'] = params['subCategory'] ? params['subCategory'] : params['parentCategory'];
          query['category_parent_url'] = params['parentCategory'];
        }

        // Handle vendor URLs
        if (params && !!params['vendor_url'] && params['vendor_url'] !== '') {
          query['vendor_url'] = params['vendor_url'];
          delete query['vendor_id'];
          delete query['category_url'];
          delete query['category_parent_url'];
        }

        // Set the current page
        this.page = this.pageParam;

        // Include sorting value in the query if available
        if (!!sortingValue) {
          query['sord'] = sortingValue;
        }
        if(!!this.featureTags && this.featureTags['sf_seo']){
          localStorage.removeItem('pagination');
        }
        // Fetch products based on the constructed query
        this.productsBasedOnCategory(query);
      }

      // Subscribe to query parameters for keyword or category search
      this.sub = this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.queryParams = params;

        if (params['keyword'] || params['cat']) {
          var query = {};
          if (params['keyword'] !== '') {
            query['keyword'] = params['keyword'];
          }
          if (params['cat'] !== undefined && params['cat'] !== "-1") {
            query['category_url'] = params['cat'];
            this.subscriptionService.subjectNext({ productSearch: params['cat'] });
          }
          // Check delivery conditions again
          if (checkDeliveryCalenderAndCutOffTime() === true) {
            query['edit_cart'] = 3;
          }

          // Navigate to the first page if the current page is 1
          if (this.page === '1' || this.page === 1) {
            this.router.navigate([], {
              relativeTo: this.activatedRoute, queryParams: { page: null },
              queryParamsHandling: "merge",
            });
          }

          // Set pagination and limit
          query['page'] = this.page;
          query['limit'] = this.count || this.counts[0];
          if (!!sortingValue) {
            query['sord'] = sortingValue;
          }

          // Call the API to search products
          this.pageLoaded = true;
          this.apiService.searchProducts(query)
          .pipe(takeUntil(this.destroy$))
          .subscribe(result => {
            if (isPlatformBrowser(this.platformId)) {
              this.pageLoaded = false;
            }
            this.subscriptionService.subjectNext({ setbreadcrumb: true });
            // Check the response status
            if (result['response']['status'] === 1 || result['response']['status'] === 6) {
              // Populate products and related information
              this.products = result['response']['data']['products']['products'];
              this.totalProductsCount = result['response']['data']['products']['count'];
              if (query['category_url'] && !query['keyword']) {
                this.categoryName = result['response']['data']['products']['title'];
                this.categoryDescription = result['response']['status'] === 1 ? result['response']['data']['products']['description'] : '';
                this.subCategories = result['response']['data']['products']['sub_categories'];
                this.categoryWebsiteMessage = result['response']['data']['products']['cat_web_msg'] ? result['response']['data']['products']['cat_web_msg'] : undefined;
              }
            } else if (result['response']['status'] === 404) {
              // Handle not found scenario
              this.router.navigateByUrl('**', { skipLocationChange: true });
            }
            // Set product availability status
            this.productNotAvailable = (this.products.length === 0 && this.subCategories.length === 0) ? true : false;
            this.pageLoaded = false;
          }, (error) => {
            // Handle API errors
            this.notFoundRedirect(error);
            return of(null); // In SSR, Prevent memory leaks by returning a safe value
          });
        }
      });
    }
  }
  onPageLinkClick(pageNumber){
    if (pageNumber == 1) {
      this.appHeaderService.setupAppHeader(this.storeDetailsJson, this.categories, "", 1);
    }   
  }
}
